module.exports = __webpack_public_path__ + "img/icon_map.06a1dad2.png";